var htmlDecode = require('html-entities').Html5Entities.decode;

module.exports.removeHtmlTags = function (str) {
  return str ? htmlDecode(str).replace(/<(?:.|\n)*?>/gm, '') : str;
};




// WEBPACK FOOTER //
// ./client/src/app/utils/html.js